import { itemReferenceAt } from "../../api/content/changeSetsApi";
import { getItemVersion, type ItemVersion } from "../../api/content/itemsApi";
import { listContentVersions } from "../../api/content/workflowsApi";

/** An item as it is in the project's latest content, or `null` if it is not there. */
export async function readCurrentItem(projectId: string, itemId: string, signal: AbortSignal): Promise<ItemVersion | null> {
  const [latest] = await listContentVersions(projectId, signal);
  if (latest === undefined) {
    return null;
  }
  const reference = await itemReferenceAt(projectId, latest.commit, itemId, signal);
  return reference === null ? null : getItemVersion(reference, signal);
}
